import React from "react"
import clsx from "clsx"

const initialsOf = name =>
  String(name || "").split(/\s+/).filter(Boolean).slice(0, 2).map(part => part[0].toUpperCase()).join("")

const isLight = hex => {
  const value = String(hex || "").replace("#", "")
  if (value.length !== 6) return false
  const [r, g, b] = [0, 2, 4].map(i => parseInt(value.slice(i, i + 2), 16))
  return (0.299 * r + 0.587 * g + 0.114 * b) > 170
}

const SIZES = {
  md: "w-[30px] h-[30px] text-[11px]",
  lg: "w-[40px] h-[40px] text-[14px]",
}

const PersonAvatar = ({ user, size = "md" }) => (
  <span
    className = {clsx("inline-grid place-items-center shrink-0 rounded-full font-semibold", SIZES[size],
                        isLight(user.color) ? "text-slate-900/80" : "text-white")}
    style     = {{ backgroundColor: user.color || "#64748B" }}
  >
    {user.initials || initialsOf(user.name)}
  </span>
)

export default PersonAvatar
